import React from 'react';
import { Lock, CreditCard, Download, Headphones, RefreshCw, CheckCircle } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="bg-gradient-to-b from-[#FDF6E3] to-[#f5edd8] py-20 px-4 sm:px-6 lg:px-8" data-id="element-146">
      <div className="max-w-5xl mx-auto" data-id="element-147">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-148">
          <span className="inline-block bg-[#d4a853] text-[#1e3a5a] font-bold text-sm px-4 py-1 rounded-full mb-4" data-id="element-149">
            OFERTA ESPECIAL
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1e3a5a] mb-4" data-id="element-150">
            Accedé ahora a POLÍTICA Y CIUDADANÍA 360
          </h2>
          <p className="text-xl text-gray-600" data-id="element-151">
            Resolvé el año completo con un sistema probado, claro y listo para
            usar.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#d4a853]/30" data-id="element-152">
          {/* Top Banner */}
          <div className="bg-[#1e3a5a] p-4 text-center" data-id="element-153">
            <p className="text-[#d4a853] font-bold text-lg animate-pulse" data-id="element-154">
              🎁 Incluye todos los bonos GRATIS por tiempo limitado
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-155">
            <div className="flex flex-col lg:flex-row items-center gap-10 mb-10" data-id="element-156">
              {/* Product Image */}
              <div className="w-full lg:w-1/2" data-id="element-157">
                <div className="relative" data-id="element-158">
                  <div className="absolute -inset-2 bg-gradient-to-r from-[#d4a853] to-[#1e3a5a] rounded-2xl blur opacity-20" data-id="element-159"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/3MdZ6pAmuJnbfB4t6UavwB/MOCKUP_PRINCIPAL_POLITICA_Y_CIUDADANIA.png" alt="Pack Completo Política y Ciudadanía 360" className="relative w-full rounded-xl shadow-lg transform hover:scale-105 transition duration-300" data-id="element-160" />
                </div>

                {/* What's included quick list */}
                <div className="mt-6 space-y-2" data-id="element-161">
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-162">
                    <CheckCircle className="w-4 h-4 text-green-500" data-id="element-163" />
                    <span data-id="element-164">Clases anuales completas</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-165">
                    <CheckCircle className="w-4 h-4 text-green-500" data-id="element-166" />
                    <span data-id="element-167">Secuencia pedagógica ordenada</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-168">
                    <CheckCircle className="w-4 h-4 text-green-500" data-id="element-169" />
                    <span data-id="element-170">Actividades de debate listas</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-171">
                    <CheckCircle className="w-4 h-4 text-green-500" data-id="element-172" />
                    <span data-id="element-173">Material 100% editable</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-174">
                    <CheckCircle className="w-4 h-4 text-green-500" data-id="element-175" />
                    <span data-id="element-176">+ 3 Bonos exclusivos GRATIS</span>
                  </div>
                </div>
              </div>

              {/* Pricing */}
              <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-177">
                <div className="mb-8" data-id="element-178">
                  <p className="text-gray-400 text-lg line-through mb-1" data-id="element-179">
                    Precio Normal: $49.990
                  </p>
                  <div className="flex items-center justify-center lg:justify-start gap-3 mb-2" data-id="element-180">
                    <p className="text-5xl md:text-6xl font-extrabold text-[#1e3a5a]" data-id="element-181">
                      $19.990
                    </p>
                  </div>
                  <span className="inline-block bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-bold border border-green-200" data-id="element-182">
                    ¡AHORRÁS $30.000 HOY!
                  </span>
                  <p className="text-sm text-gray-500 mt-3" data-id="element-183">
                    Pago único · Acceso inmediato · Sin suscripciones
                  </p>
                </div>

                <a href="https://checkout.rincondigital.shop/cart/53401040617747:1" target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-184">
                  <button className="w-full bg-[#d4a853] hover:bg-[#c49843] text-[#1e3a5a] text-xl font-bold py-5 px-8 rounded-xl shadow-lg border-b-4 border-[#b48833] active:border-b-0 active:translate-y-1 transform transition-all duration-200 hover:scale-105 mb-4" data-id="element-185">
                    DESCARGAR EL PACK AHORA
                  </button>
                </a>

                <p className="text-center text-sm text-gray-600 mb-6" data-id="element-186">
                  👆 Hacé clic y empezá a organizar tu año
                </p>

                <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-gray-500" data-id="element-187">
                  <div className="flex items-center gap-1" data-id="element-188">
                    <Lock className="w-4 h-4" data-id="element-189" /> Pago 100% Seguro
                  </div>
                  <div className="flex items-center gap-1" data-id="element-190">
                    <CreditCard className="w-4 h-4" data-id="element-191" /> Todos los medios
                  </div>
                  <div className="flex items-center gap-1" data-id="element-192">
                    <Download className="w-4 h-4" data-id="element-193" /> Descarga inmediata
                  </div>
                </div>
              </div>
            </div>

            {/* Benefits bar */}
            <div className="border-t border-gray-100 pt-8" data-id="element-194">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center" data-id="element-195">
                <div className="flex flex-col items-center" data-id="element-196">
                  <div className="bg-blue-50 p-3 rounded-full mb-3" data-id="element-197">
                    <Download className="w-6 h-6 text-[#1e3a5a]" data-id="element-198" />
                  </div>
                  <h4 className="font-bold text-[#1e3a5a] mb-1" data-id="element-199">
                    Descarga Inmediata
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-200">
                    Acceso al material al instante después del pago
                  </p>
                </div>
                <div className="flex flex-col items-center" data-id="element-201">
                  <div className="bg-blue-50 p-3 rounded-full mb-3" data-id="element-202">
                    <Headphones className="w-6 h-6 text-[#1e3a5a]" data-id="element-203" />
                  </div>
                  <h4 className="font-bold text-[#1e3a5a] mb-1" data-id="element-204">
                    Soporte Prioritario
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-205">
                    ¿Dudas? Te ayudamos por WhatsApp
                  </p>
                </div>
                <div className="flex flex-col items-center" data-id="element-206">
                  <div className="bg-blue-50 p-3 rounded-full mb-3" data-id="element-207">
                    <RefreshCw className="w-6 h-6 text-[#1e3a5a]" data-id="element-208" />
                  </div>
                  <h4 className="font-bold text-[#1e3a5a] mb-1" data-id="element-209">
                    Actualizaciones Gratis
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-210">
                    Acceso a todas las mejoras futuras
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}